import dayjs from 'dayjs';

/// 将日期格式化为 2021-12-02 18:08:23 这样的格式
function formatTime (dateString) {
    return dayjs(dateString).format('YYYY-MM-DD HH:mm:ss');
}

/**
 * @description 创建时间格式处理
 * @description createTime 创建时间
 * @return data 查询数据
 */
export const formatSetSearchTime = data => {
    // 校验时间格式是否为 YYYY-MM-DD HH:mm:ss
    const reg = /^(\d{1,4})\-(\d{1,2})\-(\d{1,2}) (\d{1,2}):(\d{1,2}):(\d{1,2})$/;
    if (!reg.test(data.createTime[0])) {
        data.createTime[0] = formatTime(data.createTime[0]);
        data.createTime[1] = formatTime(data.createTime[1]);
    }
    return data;
};
